export const MAP_LOADED = Symbol('MAP_LOADED');



// WEBPACK FOOTER //
// ./actions/Map.js